module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27523",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.7172",
      "conversations-error-reporting": "static-1.8448",
      "conversations-internal-pub-sub": "static-1.15522",
      "conversations-internal-schema": "static-1.12182",
      "conversations-message-history": "static-1.11158",
      "conversations-test-sdk": "static-1.9966",
      "conversations-visitor-experience-components": "static-1.20886",
      "head-dlb": "static-1.4465",
      "hs-promise-utils": "static-1.5040",
      "hs-test-utils": "static-1.7464",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10988",
      "I18n": "static-7.1483",
      "jasmine-immutable": "static-1.2484",
      "jasmine-runner": "static-1.5899",
      "quartz": "static-1.6311",
      "react-dlb": "static-1.64",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.77",
      "urlinator": "static-1.4035",
      "viral-links-lib": "static-1.6469",
      "visitor-ui-component-library": "static-1.5677",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.4130",
      "atom": "static-1.4647",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4295",
      "conversations-infrastructure": "static-1.8470",
      "conversations-prop-types": "static-1.6895",
      "conversations-visibility-tools": "static-1.5257",
      "conversations-visitor-message-history": "static-1.19623",
      "cssUtils": "static-1.635",
      "enviro": "static-4.345",
      "flux-actions": "static-1.291",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3531",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9058",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.16167",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4905",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3924",
      "sanitize-text": "static-1.7671",
      "signup-constants": "static-1.17870",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.478",
      "usage-tracker": "static-1.6887",
      "usage-tracker-core": "static-1.6737",
      "usage-tracker-multi": "static-1.5301",
      "usage-tracker-public": "static-1.6698",
      "visitor-ui-component-library-icons": "static-1.5488",
      "hs-promise-rejection-tracking": "static-1.4918",
      "raven-hubspot": "static-1.5693",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3007",
      "moment": "static-3.26",
      "quartz-config": "static-1.89",
      "quartz-core": "static-1.5530",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4338",
      "foundations-components": "static-1.7041",
      "foundations-theming": "static-1.3878",
      "UIComponents": "static-3.7935",
      "cv-backend-services": "static-1.1384",
      "immutable-less": "static-1.4075",
      "conversations-skeleton-state": "static-1.6821",
      "crm-events-viz-core": "static-1.31707",
      "icons": "static-2.599",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4172",
      "tanstack-virtual": "static-1.20",
      "ui-images": "static-2.997",
      "permission-components": "static-1.4834",
      "react-virtualized": "static-2.87",
      "HeadJS": "static-2.646",
      "framer-motion": "static-1.58",
      "hs-test-utils-bend-plugin": "static-1.2575",
      "msw": "static-1.39",
      "testing-library": "static-1.140",
      "i18n-data": "static-1.211",
      "moment-timezone": "static-5.73",
      "jasmine": "static-4.3792",
      "signup-ui-url-generator": "static-2.7565",
      "HubStyle": "static-2.11296",
      "sassPrefix": "static-1.145",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3496",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5304",
      "bender-build-tools": "static-1.2659",
      "dispatcher": "static-1.126",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.723",
      "hub-http-shared-msw-handlers": "static-1.8815",
      "hubspotter-http": "static-1.4160",
      "hubspotter-http-shared-msw-handlers": "static-1.8813",
      "mobile-manifest-mixins": "static-1.419",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.335",
      "hs-story-utils": "static-1.8883",
      "bend-plugin-foundations-components": "static-1.3310",
      "floating-ui": "static-1.46",
      "foundations-theming-specialty": "static-1.1594",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2361",
      "foundations-theming-base": "static-1.2863",
      "stylex": "static-1.22",
      "ts-schema": "static-1.3672",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.2018",
      "content-assistance-lib": "static-1.7133",
      "crm-component-utils": "static-1.37832",
      "crm-display-components": "static-1.23582",
      "crm-fe-perf": "static-1.22449",
      "crm-links": "static-1.5707",
      "crm-message-bus": "static-1.41679",
      "crm-search-service-types": "static-1.763",
      "crm-source-interpretation-lib": "static-1.4785",
      "customer-data-communicator": "static-1.44222",
      "customer-data-email": "static-1.17158",
      "customer-data-filters-ui": "static-1.38003",
      "customer-data-objects": "static-1.7160",
      "customer-data-objects-ui-components": "static-1.12512",
      "customer-data-properties": "static-1.49992",
      "customer-data-rte": "static-1.31829",
      "customer-data-ui-utilities": "static-1.9283",
      "data-fetching-client": "static-1.9192",
      "draft-plugins": "static-2.20786",
      "file-manager-components": "static-1.22135",
      "FileManagerCore": "static-1.37634",
      "frontend-preferences-client": "static-1.7473",
      "hubspot-apollo-client": "static-1.4326",
      "hubspot-prosemirror": "static-1.16917",
      "object-comments-thread-lib": "static-1.9480",
      "reference-resolvers-lite": "static-1.7563",
      "ui-addon-upgrades": "static-9.17180",
      "universal-associations-select": "static-1.10492",
      "graphql": "static-1.72",
      "ai-components-ui-library": "static-1.7644",
      "superstore": "static-1.4245",
      "ui-addon-video-player": "static-1.8280",
      "ui-coaching-tips": "static-1.27232",
      "card-properties-lib": "static-1.42833",
      "crm-actions": "static-1.5706",
      "crm-cards-data": "static-1.679",
      "crm-cards-sdk": "static-1.42189",
      "customer-data-properties-shared-msw-handlers": "static-1.8142",
      "customer-data-property-utils": "static-1.7511",
      "customer-data-tracking": "static-1.6399",
      "framework-data-schema-resolvers": "static-1.6373",
      "usage-tracker-container": "static-1.6877",
      "framework-data-table": "static-2.10817",
      "location-customization-utils-lib": "static-1.7793",
      "calling-error-reporting": "static-1.30831",
      "calling-internal-common": "static-1.30825",
      "calling-usage-tracker": "static-1.6045",
      "crm_data": "static-4.90429",
      "crm_schema": "static-3.90468",
      "crm-legacy-global-containers": "static-1.23313",
      "customer-data-content": "static-1.26354",
      "draft-content-plugins": "static-1.27205",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23192",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22901",
      "EmailSignatureEditor": "static-1.23463",
      "FileManagerLib": "static-1.37775",
      "hubspot-prosemirror-plugins": "static-1.16909",
      "integration-settings-components": "static-1.13962",
      "integrations-lib": "static-1.14653",
      "integrations-tracking-lib": "static-1.5142",
      "native-integrations-shared-strings": "static-1.7296",
      "nav-meta": "static-1.28247",
      "onboarding-scopes": "static-1.5994",
      "outreach-assistant-email-generation": "static-1.5289",
      "property-translator": "static-1.4887",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36410",
      "react-colorpicker": "static-2.9742",
      "react-dnd-compat": "static-1.4141",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7725",
      "rich-text-lib": "static-1.18937",
      "sales-email-signature-service-client": "static-1.3404",
      "sequences-lib": "static-1.7303",
      "timezone-utils": "static-2.4709",
      "ui-addon-i18n": "static-1.10545",
      "ui-addon-iframeable": "static-1.8438",
      "ui-business-units-lib": "static-1.8463",
      "ui-gdpr-components": "static-1.9779",
      "ui-shepherd-react": "static-3.9595",
      "user-context": "static-1.4644",
      "whatsapp-sending-lib": "static-1.4259",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4209",
      "salesImages": "static-1.514",
      "customer-data-filters-ui-msw-helpers": "static-1.20437",
      "customer-data-reference-ui-components": "static-1.12576",
      "FormUrlGenerator": "static-2.4188",
      "framework-builder-read-service-client": "static-1.3561",
      "framework-data-schema-quick-fetch": "static-1.6278",
      "inbound-db-meta-service-client": "static-1.3237",
      "inbound-db-properties-service-client": "static-1.3466",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.523",
      "onboarding-tours": "static-1.15919",
      "reporting-datasets-permissions-lib": "static-1.12258",
      "SharedI18nStrings": "static-1.175",
      "ui-addon-teams": "static-1.20893",
      "calling-global-api": "static-1.62868",
      "calling-lifecycle-internal": "static-1.64250",
      "calling-lifecycle-messages": "static-1.56544",
      "commerce-products-lib": "static-1.8075",
      "conditional-properties-service-client": "static-1.3407",
      "external-options-client-types": "static-1.3626",
      "google-libphonenumber": "static-1.27",
      "inbound-db-associations-writes-service-client": "static-1.2729",
      "inbounddb-objects-service-types": "static-1.3713",
      "meetings-icalendar-utils-lib": "static-1.47",
      "multi-currency-client-types": "static-1.3243",
      "object-builder-ui-client": "static-1.47165",
      "pipeline-validation-client-types": "static-1.3467",
      "property-value-citations": "static-1.606",
      "smart-property-lib": "static-1.4964",
      "tiered-pricing": "static-1.435",
      "ui-addon-form-validation": "static-1.10511",
      "immerable": "static-1.3614",
      "video-components-external": "static-1.9874",
      "video-data-lib": "static-1.33532",
      "audio-components": "static-1.5301",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35286",
      "video-components": "static-1.11877",
      "video-embed": "static-1.34366",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.23996",
      "knowledge-content-types": "static-1.8145",
      "payment-link-components": "static-1.22301",
      "ui-addon-emoji-picker": "static-1.9412",
      "call-summary": "static-1.37559",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.8961",
      "batch-promise": "static-1.1100",
      "fast-json-stable-stringify": "static-1.4",
      "feature-store-service-types": "static-1.4106",
      "growth-monetization-service-types": "static-1.4113",
      "merchandise-lib": "static-1.248",
      "purchase-motions-components": "static-1.5032",
      "self-service-api": "static-1.9726",
      "upgrade-management-service-types": "static-1.4097",
      "chatspot-client-types": "static-1.10194",
      "chatspot-core": "static-1.19439",
      "ContentUtils": "static-1.66871",
      "copilot-toolkit": "static-1.9836",
      "growth-onboarding-feedback-components": "static-1.6006",
      "customer-data-sidebar": "static-2.44705",
      "enrichment-properties-lib": "static-1.14082",
      "persist-promise": "static-1.3257",
      "crm-pipelines-api-client-types": "static-1.3587",
      "customer-data-associations": "static-1.6775",
      "deal-intel-decorators": "static-1.475",
      "reporting-data": "static-1.65524",
      "ui-addon-draggable": "static-3.4319",
      "crm-record-cards-service-types": "static-1.3196",
      "crm_universal": "static-1.21331",
      "SalesContentIndexUI": "static-3.8413",
      "signup-ui-lego-core": "static-1.19880",
      "content-embed-lib": "static-1.6899",
      "data-model-builder-lib": "static-1.10754",
      "remote-ui": "static-1.55",
      "ui-components-test-utils": "static-1.5126",
      "ui-extensions-remote-renderer": "static-1.15805",
      "universal-page-editor-lib": "static-1.2537",
      "integrations-error-boundary-lib": "static-1.12068",
      "laboratory-lib": "static-3.6647",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9943",
      "rxjs": "static-5.10",
      "ui-universal-auth": "static-1.8369",
      "messaging-types-lib": "static-1.44589",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15607",
      "sequences-client-types-lib": "static-1.7160",
      "foundations-components-test-utils": "static-1.4525",
      "magpie-lib": "static-1.5117",
      "navigation-messaging": "static-1.5937",
      "getting-started-shared-tasks": "static-1.17192",
      "getting-started-shared-tasks-store": "static-1.16310",
      "whatsapp-management-lib": "static-1.7418",
      "growth-data-modal": "static-1.4825",
      "growth-onboarding-confetti": "static-1.2561",
      "growth-onboarding-next-action-utils": "static-1.933",
      "navigation-components": "static-1.16610",
      "ui-shepherd-tracker": "static-1.6976",
      "shared-worker-versioning": "static-1.10576",
      "calling-orchestration-shared-library": "static-1.34057",
      "products-iframe-lib": "static-1.6656",
      "products-ui-components-shared-msw-handlers": "static-1.9197",
      "breeze-intelligence-kit": "static-1.4917",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8898",
      "fsm": "static-1.3201",
      "policy-lib": "static-1.6287",
      "react-tinymce": "static-1.53917",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53043",
      "tinymce-plugins": "static-1.56157",
      "tinymce-themes": "static-1.55013",
      "content-media-composition-data-lib": "static-1.10276",
      "content-media-compositions": "static-2.14283",
      "idb-keyval": "static-1.34",
      "magpie-types": "static-1.4577",
      "media-bridge-lib": "static-1.18162",
      "content-icons-ui": "static-1.2050",
      "social-insights-client-types": "static-1.20704",
      "outpost": "static-1.3804",
      "commerce-analytics-service-client": "static-1.3182",
      "ui-addon-opt": "static-4.7956",
      "commerce-tours-lib": "static-1.5315",
      "growth-onboarding-reliability": "static-1.4641",
      "sales-checkout-service-client": "static-1.3194",
      "ai-addon-copilot-preview": "static-1.6856",
      "calling-cross-tab-library": "static-1.18798",
      "wootric-nps": "static-1.6423",
      "nav-client-types": "static-1.1792",
      "purchase-motions-api": "static-1.5034",
      "trials-service-types": "static-1.3514",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4205",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2500",
      "card-payment-highlight-lib": "static-1.35825",
      "card-subscription-highlight-lib": "static-1.38213",
      "commerce-billing-lib": "static-1.17784",
      "commerce-contract-lib": "static-1.10342",
      "crm_components": "static-3.90429",
      "invoices-highlight-card-lib": "static-1.53244",
      "orders-highlight-card-lib": "static-1.20326",
      "products-highlight-card-lib": "static-1.16359",
      "project-storage": "static-1.4168",
      "quotes-highlight-card-lib": "static-1.70324",
      "usage-based-billing-components-lib": "static-1.7342",
      "deal-intel-utils": "static-1.479",
      "reporting-client-types": "static-1.2281",
      "react-flip-move": "static-1.60",
      "FireAlarmUi": "static-1.4110",
      "sales-templates-service-types-lib": "static-1.3751",
      "ui-asset-management-lib": "static-1.10316",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.8955",
      "collaboration-sidebar": "static-1.56534",
      "data-model-commons-lib": "static-1.11310",
      "feedback-loader": "static-1.28321",
      "final-form": "static-1.60",
      "html-to-image": "static-1.44",
      "object-definition-builder-lib": "static-1.6547",
      "property-management-iframe": "static-1.11417",
      "reactflow": "static-1.51",
      "simple-data-table": "static-1.1414",
      "used-in-list-lib": "static-1.6402",
      "visual-association": "static-1.5329",
      "highcharts": "static-8.94",
      "reporting-visualizations": "static-1.57601",
      "ui-extensibility-client-types": "static-1.3534",
      "automation-platform-service-types": "static-1.2353",
      "ContentData": "static-1.66946",
      "email-portal-health-service-types": "static-1.540",
      "marketing-email-service-types": "static-1.1642",
      "reactive-lib": "static-1.250",
      "content-whatsapp-service-types": "static-1.92",
      "marketing-platform-lib": "static-1.6261",
      "short-messages-app-service-client": "static-1.3551",
      "ui-tool-access": "static-1.9598",
      "calling-orchestration-schema": "static-1.34282",
      "sales-views-client-types": "static-1.3751",
      "trellis-story-utils": "static-1.4027",
      "storybook-react": "static-1.22",
      "hub-http-contrib": "static-1.2619",
      "interframe": "static-3.4254",
      "tinymce-data": "static-1.39128",
      "ui-addon-sales-email": "static-1.4714",
      "codemirror": "static-5.85",
      "layout-dnd-components": "static-1.11553",
      "layout-dnd-utils": "static-1.10528",
      "react-codemirror": "static-1.10155",
      "ui-brand-identity-lib": "static-1.12753",
      "NamespacedHubStyle": "static-2.8689",
      "hls.js": "static-1.29",
      "js-cookie": "static-1.18",
      "onboarding-tours-client": "static-1.4133",
      "ai-rendering-library": "static-1.8570",
      "ai-settings-ui-library": "static-1.6957",
      "chirp-fetch": "static-1.1455",
      "copilot-plugins": "static-1.9809",
      "eligibility-engine-service-types": "static-1.2795",
      "commerce-shared-components-lib": "static-1.17237",
      "commerce-subscription-lib": "static-1.35790",
      "commerce-tools-ui-lib": "static-1.9221",
      "usage-tracker-session-replay": "static-1.4573",
      "utility-belt": "static-1.1995",
      "payments-enrollment-embed-lib": "static-1.21147",
      "quotes-ui-lib": "static-1.79041",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6239",
      "invoices-ui-lib": "static-1.53260",
      "commerce-products-api": "static-1.1506",
      "SafeStorage": "static-1.3856",
      "invoices-iframe-lib": "static-1.55318",
      "quotes-modal-lib": "static-1.100998",
      "reporting-ui-components": "static-2.62798",
      "subscription-experience-data-types": "static-1.14152",
      "association-translator": "static-1.2666",
      "crm-settings-header-lib": "static-1.7746",
      "settings-ui-nav": "static-2.9697",
      "chatspot-widget-iframe": "static-1.19431",
      "collaboration-sidebar-common": "static-1.1330",
      "property-management-common": "static-1.3704",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14400",
      "advanced-menus-lib": "static-1.11423",
      "ExportDialog": "static-6.9951",
      "ui-memberships-settings-lib": "static-1.32698",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8853",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.12818",
      "highlight.js": "static-1.69",
      "reporting-action-components": "static-1.39991",
      "ui-addon-react-router-dom": "static-1.9088",
      "growth-onboarding-empty-states": "static-1.5024",
      "InboxConnectUtils": "static-4.13593",
      "payments-post-enroll-local-storage-lib": "static-1.4546",
      "qrcode-generator": "static-1.59",
      "amplitude-session-replay-browser": "static-1.50",
      "marketplace-ui-apps-core": "static-1.16782",
      "stripe-embedded-components": "static-1.6735",
      "products-ui-components": "static-1.38594",
      "totals-ui-components": "static-1.22279",
      "reporting-plugins": "static-1.9568",
      "reporting-reports": "static-1.65204",
      "reporting-snowflake": "static-1.54144",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14399",
      "simple-menus-lib": "static-1.15916",
      "academy-common-lib": "static-1.12278",
      "dashboard-lib": "static-1.79642",
      "share-with-third-party-component-lib": "static-1.8207",
      "developer-experience-shared-components": "static-1.9921",
      "marketplace-ui-client-types": "static-1.15655",
      "marketplace-ui-common": "static-1.18248",
      "ui-addon-integrations-directory-panel": "static-2.7513",
      "stripe-connect-js": "static-1.43",
      "commerce-permissions": "static-1.255",
      "property-description-translator": "static-1.3332",
      "commerce-totals-service-types": "static-1.3352",
      "campaign-roi-lib": "static-1.7512",
      "academy-service-client": "static-1.3147",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3447",
      "oauth-service-types": "static-1.3757",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27523",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.7172",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8448",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15522",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12182",
      "conversations-message-history": "/conversations-message-history/static-1.11158",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9966",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20886",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-promise-utils": "/hs-promise-utils/static-1.5040",
      "hs-test-utils": "/hs-test-utils/static-1.7464",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10988",
      "I18n": "/I18n/static-7.1483",
      "jasmine-immutable": "/jasmine-immutable/static-1.2484",
      "jasmine-runner": "/jasmine-runner/static-1.5899",
      "quartz": "/quartz/static-1.6311",
      "react-dlb": "/react-dlb/static-1.64",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4035",
      "viral-links-lib": "/viral-links-lib/static-1.6469",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5677",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4130",
      "atom": "/atom/static-1.4647",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4295",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8470",
      "conversations-prop-types": "/conversations-prop-types/static-1.6895",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5257",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19623",
      "cssUtils": "/cssUtils/static-1.635",
      "enviro": "/enviro/static-4.345",
      "flux-actions": "/flux-actions/static-1.291",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9058",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.16167",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4905",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3924",
      "sanitize-text": "/sanitize-text/static-1.7671",
      "signup-constants": "/signup-constants/static-1.17870",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.478",
      "usage-tracker": "/usage-tracker/static-1.6887",
      "usage-tracker-core": "/usage-tracker-core/static-1.6737",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5301",
      "usage-tracker-public": "/usage-tracker-public/static-1.6698",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5488",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3007",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.89",
      "quartz-core": "/quartz-core/static-1.5530",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4338",
      "foundations-components": "/foundations-components/static-1.7041",
      "foundations-theming": "/foundations-theming/static-1.3878",
      "UIComponents": "/UIComponents/static-3.7935",
      "cv-backend-services": "/cv-backend-services/static-1.1384",
      "immutable-less": "/immutable-less/static-1.4075",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6821",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31707",
      "icons": "/icons/static-2.599",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4172",
      "tanstack-virtual": "/tanstack-virtual/static-1.20",
      "ui-images": "/ui-images/static-2.997",
      "permission-components": "/permission-components/static-1.4834",
      "react-virtualized": "/react-virtualized/static-2.87",
      "HeadJS": "/HeadJS/static-2.646",
      "framer-motion": "/framer-motion/static-1.58",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2575",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.140",
      "i18n-data": "/i18n-data/static-1.211",
      "moment-timezone": "/moment-timezone/static-5.73",
      "jasmine": "/jasmine/static-4.3792",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7565",
      "HubStyle": "/HubStyle/static-2.11296",
      "sassPrefix": "/sassPrefix/static-1.145",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3496",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5304",
      "bender-build-tools": "/bender-build-tools/static-1.2659",
      "dispatcher": "/dispatcher/static-1.126",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.723",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8815",
      "hubspotter-http": "/hubspotter-http/static-1.4160",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8813",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.419",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.335",
      "hs-story-utils": "/hs-story-utils/static-1.8883",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3310",
      "floating-ui": "/floating-ui/static-1.46",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1594",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2361",
      "foundations-theming-base": "/foundations-theming-base/static-1.2863",
      "stylex": "/stylex/static-1.22",
      "ts-schema": "/ts-schema/static-1.3672",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.2018",
      "content-assistance-lib": "/content-assistance-lib/static-1.7133",
      "crm-component-utils": "/crm-component-utils/static-1.37832",
      "crm-display-components": "/crm-display-components/static-1.23582",
      "crm-fe-perf": "/crm-fe-perf/static-1.22449",
      "crm-links": "/crm-links/static-1.5707",
      "crm-message-bus": "/crm-message-bus/static-1.41679",
      "crm-search-service-types": "/crm-search-service-types/static-1.763",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4785",
      "customer-data-communicator": "/customer-data-communicator/static-1.44222",
      "customer-data-email": "/customer-data-email/static-1.17158",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38003",
      "customer-data-objects": "/customer-data-objects/static-1.7160",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12512",
      "customer-data-properties": "/customer-data-properties/static-1.49992",
      "customer-data-rte": "/customer-data-rte/static-1.31829",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9283",
      "data-fetching-client": "/data-fetching-client/static-1.9192",
      "draft-plugins": "/draft-plugins/static-2.20786",
      "file-manager-components": "/file-manager-components/static-1.22135",
      "FileManagerCore": "/FileManagerCore/static-1.37634",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7473",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4326",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16917",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9480",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7563",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17180",
      "universal-associations-select": "/universal-associations-select/static-1.10492",
      "graphql": "/graphql/static-1.72",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7644",
      "superstore": "/superstore/static-1.4245",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8280",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27232",
      "card-properties-lib": "/card-properties-lib/static-1.42833",
      "crm-actions": "/crm-actions/static-1.5706",
      "crm-cards-data": "/crm-cards-data/static-1.679",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42189",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8142",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7511",
      "customer-data-tracking": "/customer-data-tracking/static-1.6399",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6373",
      "usage-tracker-container": "/usage-tracker-container/static-1.6877",
      "framework-data-table": "/framework-data-table/static-2.10817",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7793",
      "calling-error-reporting": "/calling-error-reporting/static-1.30831",
      "calling-internal-common": "/calling-internal-common/static-1.30825",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6045",
      "crm_data": "/crm_data/static-4.90429",
      "crm_schema": "/crm_schema/static-3.90468",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23313",
      "customer-data-content": "/customer-data-content/static-1.26354",
      "draft-content-plugins": "/draft-content-plugins/static-1.27205",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23192",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22901",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23463",
      "FileManagerLib": "/FileManagerLib/static-1.37775",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.16909",
      "integration-settings-components": "/integration-settings-components/static-1.13962",
      "integrations-lib": "/integrations-lib/static-1.14653",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5142",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7296",
      "nav-meta": "/nav-meta/static-1.28247",
      "onboarding-scopes": "/onboarding-scopes/static-1.5994",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5289",
      "property-translator": "/property-translator/static-1.4887",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36410",
      "react-colorpicker": "/react-colorpicker/static-2.9742",
      "react-dnd-compat": "/react-dnd-compat/static-1.4141",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7725",
      "rich-text-lib": "/rich-text-lib/static-1.18937",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3404",
      "sequences-lib": "/sequences-lib/static-1.7303",
      "timezone-utils": "/timezone-utils/static-2.4709",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10545",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8438",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8463",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9779",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9595",
      "user-context": "/user-context/static-1.4644",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4259",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4209",
      "salesImages": "/salesImages/static-1.514",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20437",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12576",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4188",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3561",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6278",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3237",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3466",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.523",
      "onboarding-tours": "/onboarding-tours/static-1.15919",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12258",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.175",
      "ui-addon-teams": "/ui-addon-teams/static-1.20893",
      "calling-global-api": "/calling-global-api/static-1.62868",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64250",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56544",
      "commerce-products-lib": "/commerce-products-lib/static-1.8075",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3407",
      "external-options-client-types": "/external-options-client-types/static-1.3626",
      "google-libphonenumber": "/google-libphonenumber/static-1.27",
      "inbound-db-associations-writes-service-client": "/inbound-db-associations-writes-service-client/static-1.2729",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3713",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.47",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3243",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47165",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3467",
      "property-value-citations": "/property-value-citations/static-1.606",
      "smart-property-lib": "/smart-property-lib/static-1.4964",
      "tiered-pricing": "/tiered-pricing/static-1.435",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10511",
      "immerable": "/immerable/static-1.3614",
      "video-components-external": "/video-components-external/static-1.9874",
      "video-data-lib": "/video-data-lib/static-1.33532",
      "audio-components": "/audio-components/static-1.5301",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35286",
      "video-components": "/video-components/static-1.11877",
      "video-embed": "/video-embed/static-1.34366",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.23996",
      "knowledge-content-types": "/knowledge-content-types/static-1.8145",
      "payment-link-components": "/payment-link-components/static-1.22301",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9412",
      "call-summary": "/call-summary/static-1.37559",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8961",
      "batch-promise": "/batch-promise/static-1.1100",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "feature-store-service-types": "/feature-store-service-types/static-1.4106",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4113",
      "merchandise-lib": "/merchandise-lib/static-1.248",
      "purchase-motions-components": "/purchase-motions-components/static-1.5032",
      "self-service-api": "/self-service-api/static-1.9726",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4097",
      "chatspot-client-types": "/chatspot-client-types/static-1.10194",
      "chatspot-core": "/chatspot-core/static-1.19439",
      "ContentUtils": "/ContentUtils/static-1.66871",
      "copilot-toolkit": "/copilot-toolkit/static-1.9836",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6006",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44705",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14082",
      "persist-promise": "/persist-promise/static-1.3257",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3587",
      "customer-data-associations": "/customer-data-associations/static-1.6775",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.475",
      "reporting-data": "/reporting-data/static-1.65524",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4319",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3196",
      "crm_universal": "/crm_universal/static-1.21331",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8413",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19880",
      "content-embed-lib": "/content-embed-lib/static-1.6899",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10754",
      "remote-ui": "/remote-ui/static-1.55",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5126",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15805",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2537",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12068",
      "laboratory-lib": "/laboratory-lib/static-3.6647",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9943",
      "rxjs": "/rxjs/static-5.10",
      "ui-universal-auth": "/ui-universal-auth/static-1.8369",
      "messaging-types-lib": "/messaging-types-lib/static-1.44589",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15607",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7160",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4525",
      "magpie-lib": "/magpie-lib/static-1.5117",
      "navigation-messaging": "/navigation-messaging/static-1.5937",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17192",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16310",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7418",
      "growth-data-modal": "/growth-data-modal/static-1.4825",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2561",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.933",
      "navigation-components": "/navigation-components/static-1.16610",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6976",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10576",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34057",
      "products-iframe-lib": "/products-iframe-lib/static-1.6656",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9197",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4917",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8898",
      "fsm": "/fsm/static-1.3201",
      "policy-lib": "/policy-lib/static-1.6287",
      "react-tinymce": "/react-tinymce/static-1.53917",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53043",
      "tinymce-plugins": "/tinymce-plugins/static-1.56157",
      "tinymce-themes": "/tinymce-themes/static-1.55013",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10276",
      "content-media-compositions": "/content-media-compositions/static-2.14283",
      "idb-keyval": "/idb-keyval/static-1.34",
      "magpie-types": "/magpie-types/static-1.4577",
      "media-bridge-lib": "/media-bridge-lib/static-1.18162",
      "content-icons-ui": "/content-icons-ui/static-1.2050",
      "social-insights-client-types": "/social-insights-client-types/static-1.20704",
      "outpost": "/outpost/static-1.3804",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3182",
      "ui-addon-opt": "/ui-addon-opt/static-4.7956",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5315",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4641",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3194",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6856",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18798",
      "wootric-nps": "/wootric-nps/static-1.6423",
      "nav-client-types": "/nav-client-types/static-1.1792",
      "purchase-motions-api": "/purchase-motions-api/static-1.5034",
      "trials-service-types": "/trials-service-types/static-1.3514",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4205",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2500",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35825",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38213",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17784",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10342",
      "crm_components": "/crm_components/static-3.90429",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53244",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20326",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16359",
      "project-storage": "/project-storage/static-1.4168",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70324",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7342",
      "deal-intel-utils": "/deal-intel-utils/static-1.479",
      "reporting-client-types": "/reporting-client-types/static-1.2281",
      "react-flip-move": "/react-flip-move/static-1.60",
      "FireAlarmUi": "/FireAlarmUi/static-1.4110",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3751",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10316",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.8955",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56534",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11310",
      "feedback-loader": "/feedback-loader/static-1.28321",
      "final-form": "/final-form/static-1.60",
      "html-to-image": "/html-to-image/static-1.44",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6547",
      "property-management-iframe": "/property-management-iframe/static-1.11417",
      "reactflow": "/reactflow/static-1.51",
      "simple-data-table": "/simple-data-table/static-1.1414",
      "used-in-list-lib": "/used-in-list-lib/static-1.6402",
      "visual-association": "/visual-association/static-1.5329",
      "highcharts": "/highcharts/static-8.94",
      "reporting-visualizations": "/reporting-visualizations/static-1.57601",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3534",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2353",
      "ContentData": "/ContentData/static-1.66946",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.540",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1642",
      "reactive-lib": "/reactive-lib/static-1.250",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.92",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6261",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3551",
      "ui-tool-access": "/ui-tool-access/static-1.9598",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34282",
      "sales-views-client-types": "/sales-views-client-types/static-1.3751",
      "trellis-story-utils": "/trellis-story-utils/static-1.4027",
      "storybook-react": "/storybook-react/static-1.22",
      "hub-http-contrib": "/hub-http-contrib/static-1.2619",
      "interframe": "/interframe/static-3.4254",
      "tinymce-data": "/tinymce-data/static-1.39128",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4714",
      "codemirror": "/codemirror/static-5.85",
      "layout-dnd-components": "/layout-dnd-components/static-1.11553",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10528",
      "react-codemirror": "/react-codemirror/static-1.10155",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12753",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8689",
      "hls.js": "/hls.js/static-1.29",
      "js-cookie": "/js-cookie/static-1.18",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4133",
      "ai-rendering-library": "/ai-rendering-library/static-1.8570",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6957",
      "chirp-fetch": "/chirp-fetch/static-1.1455",
      "copilot-plugins": "/copilot-plugins/static-1.9809",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2795",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17237",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35790",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9221",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4573",
      "utility-belt": "/utility-belt/static-1.1995",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21147",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79041",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6239",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53260",
      "commerce-products-api": "/commerce-products-api/static-1.1506",
      "SafeStorage": "/SafeStorage/static-1.3856",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55318",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.100998",
      "reporting-ui-components": "/reporting-ui-components/static-2.62798",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14152",
      "association-translator": "/association-translator/static-1.2666",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7746",
      "settings-ui-nav": "/settings-ui-nav/static-2.9697",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19431",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1330",
      "property-management-common": "/property-management-common/static-1.3704",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14400",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11423",
      "ExportDialog": "/ExportDialog/static-6.9951",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32698",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8853",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.12818",
      "highlight.js": "/highlight.js/static-1.69",
      "reporting-action-components": "/reporting-action-components/static-1.39991",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9088",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5024",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13593",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4546",
      "qrcode-generator": "/qrcode-generator/static-1.59",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.50",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16782",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6735",
      "products-ui-components": "/products-ui-components/static-1.38594",
      "totals-ui-components": "/totals-ui-components/static-1.22279",
      "reporting-plugins": "/reporting-plugins/static-1.9568",
      "reporting-reports": "/reporting-reports/static-1.65204",
      "reporting-snowflake": "/reporting-snowflake/static-1.54144",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14399",
      "simple-menus-lib": "/simple-menus-lib/static-1.15916",
      "academy-common-lib": "/academy-common-lib/static-1.12278",
      "dashboard-lib": "/dashboard-lib/static-1.79642",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8207",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9921",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15655",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18248",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7513",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "commerce-permissions": "/commerce-permissions/static-1.255",
      "property-description-translator": "/property-description-translator/static-1.3332",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3352",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7512",
      "academy-service-client": "/academy-service-client/static-1.3147",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3447",
      "oauth-service-types": "/oauth-service-types/static-1.3757",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};